'use strict';

module.exports = {
    JET_TRANSFER_QUEUED: 'com.signiant.jet.transfer.queued',
    JET_TRANSFER_IN_PROGRESS: 'com.signiant.jet.transfer.inProgress',
    JET_TRANSFER_FAILED: 'com.signiant.jet.transfer.failed',
    JET_TRANSFER_CANCELED: 'com.signiant.jet.transfer.canceled',
    JET_TRANSFER_COMPLETED: 'com.signiant.jet.transfer.completed'
};